/**
 * Values for the supplier's `item_sort_field`: how catalog item lists are ordered after Item Order.
 * A set Item Order always sorts first; this picks the key for items without one (or tied). Null = ITEM_ORDER.
 */
enum ItemSortFieldEnum {
    /**
     * Item Order, then SKU, then name (the default).
     */
    ITEM_ORDER = "item_order",
    /**
     * Item Order, then name (A-Z), then SKU.
     */
    NAME = "name",
}

export default ItemSortFieldEnum;
